import { toast } from "react-toastify";
import { isMobile } from "react-device-detect";
import axios from "axios";
import axiosRetry from "axios-retry";

import Facebook_Logo from "../../images/FacebookSquareBtn.svg";
import Instagram_Logo from "../../images/InstagramSquareBtn.svg";
import LinkedIn_Logo from "../../images/LinkedinSquareBtn.svg";
import Twitter_Logo from "../../images/TwitterSquareBtn.svg";
import X_Logo from "../../images/X.svg";
import WhatsApp_Logo from "../../images/WhatsappSquareBtn.svg";
import SMS_Logo from "../../images/SMS_Logo.svg";
import NativeSharing_Logo from "../../images/NativeSharing_Logo.svg";
import Twitter_Dark from "../../images/TwitterInvert.svg";
import X_Dark from "../../images/X_invert.svg";
import Facebook_Dark from "../../images/FacebookInvert.svg";
import Instagram_Dark from "../../images/InstagramInvert.svg";
import LinkedIn_Dark from "../../images/LinkedinInvert.svg";
import WhatsApp_Dark from "../../images/WhatsappInvert.svg";
import NativeSharing_Dark from "../../images/NativeSharingInvert.svg";
import SMS_Dark from "../../images/SMSInvert.svg";
import XTwitter from "../../images/XTwitter.svg";



axiosRetry(axios, { retries: 3, retryCondition: (_error) => true });

export const allPlatforms = ["twitter","linkedin","facebook","instagram","whatsapp","sms","native"];

export const twitterShareStrategy = {
  behavior: {
    mobile: {
      image: "nativeWithFile",
      media: "nativeWithFile",
      youtube: "shareLink",
      giphy: "nativeWithFile",
    },
    desktop: {
      image: "shareLink",
      media: "downloadMedia",
      youtube: "shareLink",
      giphy: "downloadMedia",
    },
  },

  config: {
    platformName: "X / Twitter",
    color: "0,0,0", //"85, 173, 239", //"#55adef",
    optimizeButtonAvailable: true,
    shareIntentUrl: "https://twitter.com/intent/tweet",
    platformUrl: "https://twitter.com",
    textParam: "text",
    urlParam: "url",

    image: {
      minRatio: 1.91,
      maxRatio: 1.91,
    },
    video: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    gif: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    giphy: {
      minRatio: 1,
      maxRatio: 1.91,
    },
  },

  res: {
    logo: X_Logo,
    logo_dark: X_Dark,
    icon: XTwitter
  },
};

export const whatsappShareStrategy = {
  behavior: {
    mobile: {
      image: "nativeWithFile",
      media: "nativeWithFile",
      youtube: "shareLink",
      giphy: "nativeWithFile",
    },
    desktop: {
      image: "shareLink",
      media: "downloadMedia",
      youtube: "shareLink",
      giphy: "downloadMedia",
    },
  },

  config: {
    platformName: "WhatsApp",
    color: "32, 176, 56", //"#20b038",
    optimizeButtonAvailable: false,
    shareIntentUrl: "https://wa.me/",
    platformUrl: "https://web.whatsapp.com/",
    textParam: "text",
    urlParam: null,
    nativeSkipText: ["IOS"],
    image: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    video: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    gif: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    giphy: {
      minRatio: 1,
      maxRatio: 1.91,
    },
  },

  res: {
    logo: WhatsApp_Logo,
    logo_dark: WhatsApp_Dark
  },
};

export const facebookShareStrategy = {
  behavior: {
    mobile: {
      image: "nativeWithFile",
      media: "nativeWithFile",
      youtube: "nativeWithoutFile",
      giphy: "nativeWithFile",
    },
    desktop: {
      image: "shareLink",
      media: "downloadMedia",
      youtube: "shareLink",
      giphy: "shareLink",
    },
  },
  config: {
    platformName: "Facebook",
    optimizeButton: false,
    color: "58, 89, 152", //"#3a5998",
    shareIntentUrl: "https://www.facebook.com/sharer/sharer.php",
    platformUrl: "https://www.facebook.com",
    textParam: null,
    urlParam: "u",
    nativeSkipText: ["IOS"],
    image: {
      minRatio: 1.91,
      maxRatio: 1.91,
    },
    video: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    gif: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    giphy: {
      minRatio: 1,
      maxRatio: 1.91,
    },
  },

  res: {
    logo: Facebook_Logo,
    logo_dark: Facebook_Dark
  },
};

export const linkedinShareStrategy = {
  behavior: {
    mobile: {
      image: "nativeWithFile",
      media: "nativeWithFile",
      youtube: "shareLink",
      giphy: "nativeWithFile",
    },
    desktop: {
      image: "shareLink",
      media: "downloadMedia",
      youtube: "shareLink",
      giphy: "shareLink",
    },
    IOS: { nativeWithFile: "shareLink" }, // overwrite behavior for specific social network
  },
  config: {
    platformName: "LinkedIn",
    optimizeButton: false,
    color: "31, 136, 190", //"#1f88be",
    shareIntentUrl: "https://www.linkedin.com/shareArticle?mini=true",
    platformUrl: "https://www.linkedin.com",
    textParam: null,
    urlParam: "url",
    image: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    video: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    gif: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    giphy: {
      minRatio: 1,
      maxRatio: 1.91,
    },
  },

  res: {
    logo: LinkedIn_Logo,
    logo_dark: LinkedIn_Dark
  },
};

export const instagramShareStrategy = {
  behavior: {
    mobile: {
      image: "nativeWithFile",
      media: "nativeWithFile",
      youtube: "shareLink",
      giphy: "nativeWithFile",
    },
    desktop: {
      image: "downloadMedia",
      media: "downloadMedia",
      youtube: "shareLink",
      giphy: "downloadMedia",
    },
  },
  config: {
    platformName: "Instagram",
    optimizeButton: false,
    color: "223,67,126", //"#ce2d9d", -> #df437e
    shareIntentUrl: null,
    platformUrl: "https://www.instagram.com",
    textParam: null,
    urlParam: null,
    nativeSkipText: ["IOS"],
    image: {
      minRatio: 0.5,
      maxRatio: 1.91,
    },
    video: {
      minRatio: 0.5,
      maxRatio: 1.91,
    },
    gif: {
      minRatio: 0.5,
      maxRatio: 1.91,
    },
    giphy: {
      minRatio: 0.5,
      maxRatio: 1.91,
    },
  },

  res: {
    logo: Instagram_Logo,
    logo_dark: Instagram_Dark
  }
};

export const allAppsShareStrategy = {
  behavior: {
    mobile: {
      image: "nativeWithFile",
      media: "nativeWithFile",
      youtube: "nativeWithoutFile",
      giphy: "nativeWithFile",
    },
    desktop: {
      image: "nativeWithoutFile",
      media: "nativeWithoutFile",
      youtube: "nativeWithoutFile",
      giphy: "nativeWithoutFile",
    },
  },
  config: {
    platformName: "Native",
    optimizeButton: false,
    color: "102, 121, 159", //"#66799f",
    onlyMobile: true,
    shareIntentUrl: null,
    platformUrl: null,
    textParam: null,
    urlParam: null,
    image: {
      minRatio: 0.5,
      maxRatio: 1.91,
    },
    video: {
      minRatio: 0.5,
      maxRatio: 1.91,
    },
    gif: {
      minRatio: 0.5,
      maxRatio: 1.91,
    },
    giphy: {
      minRatio: 0.5,
      maxRatio: 1.91,
    },
  },
  res: {
    logo: NativeSharing_Logo,
    logo_dark: NativeSharing_Dark,
    icon: "share square"
  },
};

export const smsShareStrategy = {
  behavior: {
    mobile: {
      image: "shareLink",
      media: "nativeWithFile",
      youtube: "shareLink",
      giphy: "shareLink",
    },
    desktop: {
      image: "nativeWithoutFile",
      media: "nativeWithoutFile",
      youtube: "nativeWithoutFile",
      giphy: "nativeWithoutFile",
    },
  },
  config: {
    platformName: "SMS",
    optimizeButton: false,
    color: "32, 176, 56", //"#20b038",
    onlyMobile: true,
    shareIntentUrl: "sms:?",
    platformUrl: null,
    textParam: "body",
    urlParam: null,
    image: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    video: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    gif: {
      minRatio: 1,
      maxRatio: 1.91,
    },
    giphy: {
      minRatio: 1,
      maxRatio: 1.91,
    },
  },

  res: {
    logo: SMS_Logo,
    logo_dark: SMS_Dark,
    icon: "comment outline"
  },
};

export function getPlatformColor(socialNetwork) {
  const strategy = platformStrategy(socialNetwork);
  return (strategy ? strategy.config.color : "#5a1268");
}

export function platformStrategy(socialNetwork) {
  if (socialNetwork === "twitter") {
    return twitterShareStrategy;
  } else if (socialNetwork === "facebook") {
    return facebookShareStrategy;
  } else if (socialNetwork === "instagram") {
    return instagramShareStrategy;
  } else if (socialNetwork === "linkedin") {
    return linkedinShareStrategy;
  } else if (socialNetwork === "whatsapp") {
    return whatsappShareStrategy;
  } else if (socialNetwork === "native") {
    return allAppsShareStrategy;
  } else if (socialNetwork === "sms") {
    return smsShareStrategy;
  } else {
    return null;
  }
}

export const instagramIcon = (
  <svg
    aria-label="New Post"
    className="_8-yf5 "
    color="#262626"
    fill="#262626"
    height="22"
    role="img"
    viewBox="0 0 48 48"
    width="22"
  >
    <path d="M31.8 48H16.2c-6.6 0-9.6-1.6-12.1-4C1.6 41.4 0 38.4 0 31.8V16.2C0 9.6 1.6 6.6 4 4.1 6.6 1.6 9.6 0 16.2 0h15.6c6.6 0 9.6 1.6 12.1 4C46.4 6.6 48 9.6 48 16.2v15.6c0 6.6-1.6 9.6-4 12.1-2.6 2.5-5.6 4.1-12.2 4.1zM16.2 3C10 3 7.8 4.6 6.1 6.2 4.6 7.8 3 10 3 16.2v15.6c0 6.2 1.6 8.4 3.2 10.1 1.6 1.6 3.8 3.1 10 3.1h15.6c6.2 0 8.4-1.6 10.1-3.2 1.6-1.6 3.1-3.8 3.1-10V16.2c0-6.2-1.6-8.4-3.2-10.1C40.2 4.6 38 3 31.8 3H16.2z"></path>
    <path d="M36.3 25.5H11.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h24.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"></path>
    <path d="M24 37.8c-.8 0-1.5-.7-1.5-1.5V11.7c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v24.6c0 .8-.7 1.5-1.5 1.5z"></path>
  </svg>
);

export function pickShareBehavior(config, isMobileDevice, mediaType, os) {
  var ret = null;

  if (isMobileDevice) {
    if (mediaType === "image") {
      ret = config.mobile.image;
    } else if (mediaType === "gif" || mediaType === "video") {
      ret = config.mobile.media;
    } else if (mediaType === "youtube") {
      ret = config.mobile.youtube;
    } else if (mediaType === "giphy") {
      ret = config.mobile.giphy;
    }
  } else {
    if (mediaType === "image") {
      ret = config.desktop.image;
    } else if (mediaType === "gif" || mediaType === "video") {
      ret = config.desktop.media;
    } else if (mediaType === "youtube") {
      ret = config.desktop.youtube;
    } else if (mediaType === "giphy") {
      ret = config.desktop.giphy;
    }
  }

  if (config[os] && config[os][ret]) {
    ret = config[os][ret];
    
    if(ret==="shareLink" && 
       isMobileDevice && 
       (mediaType === "gif" || mediaType === "video")) {
      ret = "downloadMedia";
    }
  }

  return ret;
}

export async function shareNativeWithFile(media, mediaType, text) {
  const ret = await toast.promise(
    axios
      .get(media, {
        responseType: "blob",
      })
      .then((response) => {
        return response.data;
      })
      .then(async (blob) => {
        var file = new File(
          [blob],
          mediaType === "video"
            ? `video.mp4`
            : mediaType === "gif" || mediaType === "giphy"
            ? `animation.gif`
            : `image.jpeg`,
          {
            type:
              mediaType === "video"
                ? "video/mp4"
                : mediaType === "gif" || mediaType === "giphy"
                ? "image/gif"
                : "image/jpeg",
          }
        );
        const shareData = text
          ? { files: [file], text: text }
          : { files: [file] };

        if (navigator.canShare && navigator.canShare(shareData)) {
          console.log("CAN SHARE FILES");
          await navigator.share(shareData);
          return 0;
        } else {
          console.log("CANT SHARE FILES");
          return -1;
        }
      })
      .catch((err) => {
        if (!err instanceof DOMException || err.name !== "AbortError") {
          console.log(err);
          alert("Failed to download file!");
          return -1;
        }
        return 1;
      }),
    {
      pending: "Downloading media and opening share menu...",
      success: "Media download successful",
      error: "Media download failed. Please try again.",
    }
  );
  return ret;
}

export async function shareNativeWithoutFile(text, link) {
  const shareData = link ? { text: text, url: link } : { text: text };
  if (navigator.canShare && navigator.canShare(shareData)) {
    await navigator.share(shareData);
    return 0;
  }
  return -1;
}

function isWebview() {
  const navigator = window.navigator;
  const userAgent = navigator.userAgent;
  const normalizedUserAgent = userAgent.toLowerCase();
  const standalone = navigator.standalone;

  const isIos =
    /ip(ad|hone|od)/.test(normalizedUserAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isAndroid = /android/.test(normalizedUserAgent);
  const isSafari = /safari/.test(normalizedUserAgent);
  const isWebview = (isAndroid && /; wv\)/.test(normalizedUserAgent)) || (isIos && !standalone && !isSafari);

  return isWebview;
}

export async function shareLink(text, link, config, sameTab = false) {
  var platformShareLink = config.shareIntentUrl;
  var paramAppend = platformShareLink?.includes("?") ? "&" : "?";

  if (config.urlParam && link) {
    platformShareLink +=
      paramAppend + config.urlParam + "=" + encodeURIComponent(link);
    paramAppend = "&";
  }

  if (config.textParam) {
    const textToShare = config.urlParam ? text : `${text} ${link}`;
    platformShareLink +=
      paramAppend + config.textParam + "=" + encodeURIComponent(textToShare);
    paramAppend = "&";
  }

  let openInTab = isWebview();
  if (platformShareLink === config.shareIntentUrl) {
    platformShareLink = config.platformUrl;
    openInTab = true;
  }

  if(sameTab) {
    // wait a bit when opening in same tab to give registerShare() some time to fire 
    setTimeout(() => {
      window.open(platformShareLink,"_self");
    }, 500);
  } else if (isMobile) {
    window.open(platformShareLink, "_blank");
  } else if(openInTab) {
    window.open(platformShareLink, "_blank");
  } else {
    window.open(
      platformShareLink,
      "targetWindow",
      "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=650,height=550"
    );
  }

  return 0;
}
